import ScrollCarousel from '../../components/ScrollCarousel';

export const SELECTORS = {
  viewport: '[data-hero-dual-image-mobile-carousel-viewport]',
  track: '[data-hero-dual-image-mobile-carousel-track]',
};

/**
 * The mobile hero: one stacked image+content slide per block. Standalone — it
 * is not synced with the image strips, which are desktop-only.
 */
export default (el) => {
  if (!el) return null;

  return new ScrollCarousel(el, {
    selectors: SELECTORS,
    initialIndex: 0,
    prevNextButtons: true,
    pageDots: true,
    // Flickity `wrapAround: true`.
    loop: true,
    adaptiveHeight: false,
    draggable: true,
    slidesPerView: 1,
    ariaLabel: 'Hero carousel',
  });
};
